module.exports = __webpack_public_path__ + "img/slider_2.d74133f5.jpg";